[
  {
    "key": "none",
    "name": "None",
    "art": "none",
    "requiresTech": null,
    "yields": {
      "food": 0,
      "production": 0,
      "gold": 0
    },
    "validTerrain": [],
    "turnsToBuild": 0,
    "description": "Unimproved."
  },
  {
    "key": "farm",
    "name": "Farm",
    "art": "fields",
    "requiresTech": "agriculture",
    "yields": {
      "food": 1,
      "production": 0,
      "gold": 0
    },
    "validTerrain": [
      "grassland",
      "plains",
      "desert",
      "tundra"
    ],
    "turnsToBuild": 4,
    "description": "Worked fields. The plainest way to turn land into people."
  },
  {
    "key": "mine",
    "name": "Mine",
    "art": "mine",
    "requiresTech": "bronze_working",
    "yields": {
      "food": 0,
      "production": 2,
      "gold": 0
    },
    "validTerrain": [
      "hills",
      "mountains",
      "desert",
      "tundra"
    ],
    "turnsToBuild": 6,
    "description": "Cuts into the rock for ore and stone."
  },
  {
    "key": "grove",
    "name": "Managed Grove",
    "art": "orchard",
    "requiresTech": "herbal_lore",
    "yields": {
      "food": 1,
      "production": 1,
      "gold": 0
    },
    "validTerrain": [
      "grassland",
      "plains"
    ],
    "turnsToBuild": 5,
    "description": "Planted and cropped on a cycle, rather than felled once."
  },
  {
    "key": "road",
    "name": "Road",
    "art": "road",
    "route": true,
    "requiresTech": "the_wheel",
    "yields": {
      "food": 0,
      "production": 0,
      "gold": 1
    },
    "validTerrain": [
      "grassland",
      "plains",
      "desert",
      "tundra",
      "hills"
    ],
    "turnsToBuild": 2,
    "description": "A cleared and metalled way. Armies and traders move along it three times as fast, and a city it reaches is pulled closer to the palace.",
    "effects": {
      "dragReduction": 0.25,
      "connectsCities": true
    },
    "_note": "Roads are what properly soften administrative drag. A courthouse is a building; a road is the empire reaching out to meet the city.",
    "_route": "A route lies alongside whatever else is built on a tile — a road and a farm together (ADR-0055). Moving from road to road costs rules.movement.roadCost. Every city stands on a road of its own."
  },
  {
    "key": "plantation",
    "name": "Plantation",
    "art": "plantation",
    "requiresTech": "currency",
    "yields": {
      "food": 0,
      "production": 0,
      "gold": 2
    },
    "validTerrain": [
      "grassland",
      "plains"
    ],
    "turnsToBuild": 5,
    "description": "Cultivates a luxury for export rather than a crop for the table."
  },
  {
    "key": "quarry",
    "name": "Quarry",
    "art": "quarry",
    "requiresTech": "stoneworking",
    "yields": {
      "food": 0,
      "production": 2,
      "gold": 0
    },
    "validTerrain": [
      "hills",
      "mountains",
      "desert"
    ],
    "turnsToBuild": 6,
    "description": "Extracts cut stone at scale."
  }
]
